import React from 'react'
import { Grid } from '@material-ui/core'
import Discovery from '../image/Discovery.png'

const DiscoveryPlatform = () =>{
  const StyleContainer = {
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    flexDirection:'column',
    padding:'61px 95px'
  }

  const StyleTitle = {
    lineHeight: '44px',
    letterSpacing: '0em',
    textAlign: 'left',
    fontFamily: 'Public Sans',
    fontSize: '36px',
    fontWeight: 700,
    marginBottom:'22px'
  }

  const StyleSubTitle = {
    fontFamily: 'Public Sans',
    fontSize: '14px',
    fontWeight: 400,
    marginBottom:'44px'
  }

  const StyleButton = {
    padding:'8px 0px',
    color:'white',
    borderRadius:'24px',
    backgroundColor: '#48A1C8',
    border:'none',
    width:'100%',
    fontFamily: 'Public Sans',
    fontSize: '16px',
    fontWeight: 700,
    textAlign:'center'
  }

  return(
    <Grid container >
      <Grid style={StyleContainer} item xs={12} md={7}>
        <Grid item xs={12} style={StyleTitle}>Venha conhecer nossa plataforma</Grid>
        <Grid item xs={12} style={StyleSubTitle}>Criamos recursos incríveis que promovem e melhoram a qualidade de instituições de ensino através de recursos pedagógicos avançados apoiados em tecnologia de ponta.</Grid>
        <Grid item xs={12} style={{width:'100%'}}><button style={StyleButton}>Venha conhecer!</button></Grid>
      </Grid>
      <Grid item xs={12} md={5}>
        <Grid item xs={12}><img src={Discovery} style={{maxwidth: '267.53px',maxHeight: '408px'}}/></Grid>
      </Grid>
    </Grid>
  )
}

export default DiscoveryPlatform;
